module.exports = __webpack_public_path__ + "img/ic_like_active.2707cc36.svg";